import { render, staticRenderFns } from "./Learningecord.vue?vue&type=template&id=54e31fd2&scoped=true&"
import script from "./Learningecord.vue?vue&type=script&lang=js&"
export * from "./Learningecord.vue?vue&type=script&lang=js&"
import style0 from "./Learningecord.vue?vue&type=style&index=0&id=54e31fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e31fd2",
  null
  
)

export default component.exports